module.exports = __webpack_public_path__ + "img/数据中心.335be2d5.png";